export const HttpRequest = (Toppic, Body) => {

    let sessiontoken = localStorage.getItem("sessiontoken");
    //console.log("sessiontoken:"+sessiontoken);
    let configpath = `${process.env.PUBLIC_URL}/config.json`;
    //console.log("configpath:"+configpath);
    const Request = new Promise((resolve, reject) => {
        fetch(configpath)
            .then(res => res.json())
            .then(config => {
                //console.log(config);
                const options = {
                    method: 'POST', // *GET, POST, PUT, DELETE, etc.
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET, POST',
                        'Access-Control-Allow-Headers': 'Content-Type',
                        'sessiontoken': sessiontoken
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                    body: JSON.stringify(Body) // body data type must match "Content-Type" header
                }
                
                fetch(config.apiendpoint + Toppic, options)
                    .then(response => response.json())
                    .then(data => { resolve(data) })
                    .catch((error) => { reject(error) });

            }).catch(err => { console.log(err, ' error') });
    });
    
    return Request;
    
}